module.exports = __webpack_public_path__ + "img/ocean-kids-2.c1da4955.jpg";